module.exports = __webpack_public_path__ + "img/dk.286a2580.svg";